import React, {useState, useEffect} from 'react'
import SubscriptionCards from './Components/SubscriptionCards'
import {getSubscriptionList} from './SettingAPI'
import Swal from 'sweetalert2'
import {CircularProgress} from '@mui/material'
import { subscriptionDataType } from './settingsDataType'

const Subscription = () => {
  const [subscriptions, setSubscriptions] = useState<subscriptionDataType[]>()
  const [selectedPlanUUID, setSelectedPlanUUID] = useState<string>()
  const [loading, setLoading] = useState<boolean>(false)

  const getSubscriptionPlanList = async () => {
    setLoading(true)
    try {
      const {data: res} = await getSubscriptionList()
      if (res.code === '200') {
        setSubscriptions(res.data.plans)
        setSelectedPlanUUID(res.data.subscription_details.subscription_uuid)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: res.error.charAt(0).toUpperCase() + res.error.slice(1),
          text: `${res.msg_details}`,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getSubscriptionPlanList()
  }, [])
  return (
    <>
      {loading? (
        // {*/ Begin: Loader /*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
        // {*/ End: Loader /*}
      ) : (
        subscriptions &&
        // {Begin: Subscription cards layout}
        <div className='d-flex gap-10 align-items-end flex-wrap px-5'>
          {subscriptions?.map((item) => {
            return (
              <>
              {/* Begin: subscription card */}
                <SubscriptionCards
                  subscriptionDetails={item}
                  selected={item.subscription_uuid === selectedPlanUUID}
                  selectedPlanUUID={selectedPlanUUID}
                  getSubscriptionPlanList={getSubscriptionPlanList}
                  setLoading={setLoading}
                  loading={loading}
                />
              {/* End: subscription card */}
              </>
            )
          })}
        </div>
        // {End: Subscription cards layout}
      )}
    </>
  )
}

export default Subscription
